const DeterminationIncomeContent = `


Determination of income from transactions with non-residents.

11. [Omitted by the IT (Twenty-first Amdt.) Rules, 2001, w.e.f. 21-8-2001.]


`;

export default DeterminationIncomeContent;